import React from 'react';

import { Button, Grid, makeStyles, Typography } from '@material-ui/core';
import moment from 'moment';

import Table from '../common/Table';

const useStyles = makeStyles((theme) => {
  return {
    fieldTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: '500',
      lineHeight: '16px',
      marginBottom: '1rem',
    },
    fieldValue: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'normal',
      lineHeight: '21px',
      wordBreak: 'break-word',
    },
    oldTable: {
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    table: {
      width: '100%',
    },
  };
});

export default ({ details, onUpdate, onChangeEmail, onChangePassword }) => {
  if (!details) return null;

  const classes = useStyles();
  const fields = [
    {
      title: 'Name',
      value: details.name,
    },
    {
      title: 'Date of Birth',
      value: details.dateOfBirth ? moment.parseZone(details.dateOfBirth).format('MM/DD/YYYY') : '',
    },
    {
      title: 'Preferred Name',
      value: details.preferredName || '',
    },
    {
      title: 'Gender',
      value: details.gender ? details.gender[0].toUpperCase() + details.gender.slice(1) : '',
    },
    {
      title: 'Phone number',
      value: details.phoneNumber || '',
    },
    {
      title: 'Email address',
      value: details.email,
    },
  ];

  const renderFields = () => {
    return fields.map((field) => {
      return (
        <Grid item xs={2} container key={field.title}>
          <Grid item xs={12}>
            <Typography className={classes.fieldTitle}> {field.title} </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.fieldValue}> {field.value}</Typography>
          </Grid>
        </Grid>
      );
    });
  };
  const columns = fields.map((e) => ({ label: e.title, name: e.title }));
  const info = {};
  fields.forEach((e) => {
    info[e.title] = e.value;
  });

  return (
    <Grid item container xs={12}>
      <Grid item xs={12}>
        <Typography className="secondary-header mb-1">My Personal Details</Typography>
      </Grid>
      <Grid item container xs={12}>
        <Table columns={columns} data={[info]} className={classes.table} options={{ isRowSelectable: () => false }} />
      </Grid>
      <Grid item xs={12} className="mt-2">
        <Button variant="contained" style={{ width: '155px' }} className="mr-1" color="primary" onClick={onUpdate}>
          Update My Details
        </Button>
        <Button variant="contained" style={{ width: '155px' }} className="mr-1" color="primary" onClick={onChangeEmail}>
          Change Email
        </Button>
        <Button variant="contained" style={{ width: '155px' }} color="primary" onClick={onChangePassword}>
          Change Password
        </Button>
      </Grid>
    </Grid>
  );
};
